// extracted by mini-css-extract-plugin
export default {"root":"MemoryProgressBar_root-ELh","fill":"MemoryProgressBar_fill-UgC"};